module.exports = __webpack_public_path__ + "static/fashion-section-bg-7f0c1dfb86c93afee20349eea333b5ed.jpg";